import { faFile } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../global";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DropzoneComponent = ({ getRootProps, getInputProps, isDragActive, fileTypes }) => {
  return (
    <div
      {...getRootProps()}
      className="bg-white rounded-lg shadow-sm transition-all duration-200 overflow-hidden"
      style={{
        border: isDragActive
          ? `2px dashed ${colors.accent}`
          : `2px dashed ${colors.primary}`,
        padding: "2rem",
      }}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center justify-center text-center">
        <div
          className="mb-4 p-4 rounded-full bg-gray-50 text-5xl"
          style={{ color: colors.primary }}
        >
          <FontAwesomeIcon icon={faFile} />
        </div>
        <p
          className="text-lg font-medium mb-1"
          style={{ color: colors.primary }}
        >
          {isDragActive ? "Drop files here" : `Upload your ${fileTypes} files`}
        </p>
        <p className="text-sm text-gray-500 mb-4">
          {isDragActive
            ? "Release to upload your files"
            : "Drag & drop files here or click to browse"}
        </p>
        <button
          className="py-2 px-4 rounded text-sm font-medium"
          style={{ backgroundColor: colors.primary, color: colors.white }}
        >
          Browse Files
        </button>
      </div>
    </div>
  );
};

export default DropzoneComponent;
